import React from 'react';

const AvatarPreview = () => {
    return (
        <div className="avatar-section">
            <h2>🧍 Customise Avatar</h2>
            <p>Mix and match your items to create your look!</p>
        </div>
    );
};

export default AvatarPreview;